import {Component, OnDestroy, OnInit} from '@angular/core';
import {OcrService} from '../../../components/ocr/ocr.service';
import {OcrFileinfo} from '../../../domain/model/common/file/ocr-file-info.class';
import {FileUploaderComponentModel} from '../../../components/files/file-uploader/file-uploader.component';
import {FileLocationFactory} from '../../../components/files/service/file-location.class';
import {NavigationEnd, Router} from '@angular/router';

@Component({
    template: require('./files-upload-page.component.html'),
    styles: [require('./files-upload-page.component.scss')],
})
export class FilesUploadPageComponent implements OnInit, OnDestroy {

    files: OcrFileinfo[];
    fileUploaderModel: FileUploaderComponentModel;
    sub: any;
    loading: boolean = false;
    stompSub: any;

    constructor(protected ocrService: OcrService,
                readonly fileLocationFactory: FileLocationFactory,
                private readonly _router: Router
                ) {}

    ngOnInit(): void {
        this.sub = this._router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.fileUploaderModel = new FileUploaderComponentModel({
                    filesLocation: this.fileLocationFactory.create('', undefined, undefined, `${process.env.OCR_SERVICE_BASE_URI}/api/ocr/upload`)
                });
                this.fileUploaderModel.uploaded$.startWith(true).subscribe(_ => this.refreshFiles());
                this.refreshFiles();
            }
        });
        this.stompSub = this.ocrService.taskCompleted$.subscribe((msg_body: string) => {
            if (msg_body === 'COMPLETED') {
                this.refreshFiles();
            }
        });
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
        this.stompSub.unsubscribe();
    }

    private refreshFiles() {
        this.loading = true;
        this.ocrService.list().subscribe(
            result => {
                this.files = result;
                this.loading = false;
            }
        );
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/resume/upload/files-upload-page.component.ts